import React from "react";
import { i18n } from "../../translate/i18n";

export default function TemplateOnlyBar() {
	return (
		<div className="mx-3 mt-2 rounded-xl bg-red-600 px-3 py-2 text-center text-sm font-medium text-white">
			{i18n.t("templateOnlyBar.message")}
		</div>
	);
}
